<div
  data-e2e-id="xux-list-container"
  class="xux xux-list-container"
  [ngClass]="{ 'hidden-header-checkbox': gridOptions?.hiddenGridHeaderCheckbox }"
>
  <xux-document-info-error-message
    *ngIf="isDocumentInfoMessageShow$ | async"
    [messageData]="infoMessageData$ | async"
  ></xux-document-info-error-message>
  <div class="row">
    <div class="xux-top-panel">
      <div data-e2e-id="xux-list-title" class="col-xs-6 title-area">
        <h4>
          {{ headerName | translate}}
          <span class="deleted-text" *ngIf="inShowDeletedMode"
            >{{ I18n.Forms.GridMessages.DeletedItems | translate}}</span
          >
          <xux-tooltip-icon
            *ngIf="titleTooltipIconConfig$ | async"
            [config]="titleTooltipIconConfig$ | async"
            class="ws-connection-icon orange"
          ></xux-tooltip-icon>
        </h4>
        <span class="sub-info" *ngIf="description"
          >{{ description | translate}}<br
        /></span>
        <span class="sub-info" *ngIf="!disableItemsCountLabel">
          {{ I18n.Forms.GridMessages.ShowingEntities | translate: { count:
          pageSideTotal || 0, entities: listTotalItemsLabel$ | async } }}
        </span>
      </div>
      <div class="col-xs-6 xux-buttons-area">
        <button
          *ngIf="printButton && showPrintButton"
          type="button"
          class="btn btn-default pull-right print-btn"
          (click)="actionButtonClicked('print')"
          [disabled]="(printButton.disabledObs | async) || printButton.disabled || inShowDeletedMode"
          data-e2e-id="edit-xux-btn-print"
        >
          {{printButton.caption | translate}}
        </button>
        <button
          *ngIf="exportButton && showExportButton"
          type="button"
          class="btn btn-default"
          (click)="actionButtonClicked('export')"
          [disabled]="(exportButton.disabledObs | async) || exportButton.disabled || inShowDeletedMode"
          data-e2e-id="edit-xux-btn-export"
        >
          {{exportButton.caption | translate}}
        </button>
        <button
          *ngIf="siteAndEventSelectorButton && showSiteAndEventSelector"
          data-e2e-id="xux-select-event-btn"
          type="button"
          [class]="siteAndEventSelectorButton.class"
          (click)="actionButtonClicked('select_site_and_event')"
        >
          {{ siteAndEventSelectorButton.caption | translate }}
        </button>
        <button
          *ngIf="eventSelectorButton && showEventSelector"
          data-e2e-id="xux-select-event-btn"
          type="button"
          [class]="eventSelectorButton.class"
          (click)="actionButtonClicked('select_event')"
        >
          {{ eventSelectorButton.caption | translate }}
        </button>
        <button
          *ngIf="siteSelectorButton && showSiteSelector"
          data-e2e-id="xux-select-site-btn"
          type="button"
          [class]="siteSelectorButton.class"
          (click)="actionButtonClicked('select_site')"
        >
          {{ siteSelectorButton.caption | translate }}
        </button>
        <button
          *ngIf="printOpeningSheetsButton && showPrintOpeningSheets"
          data-e2e-id="xux-print-opening-sheets-btn"
          type="button"
          class="btn xux-btn btn-default"
          (click)="actionButtonClicked('print_opening_sheets')"
        >
          {{ printOpeningSheetsButton.caption | translate }}
        </button>
        <button
          *ngIf="autoRestocksButton"
          data-e2e-id="xux-auto-restock-btn"
          type="button"
          class="btn xux-btn btn-default"
          [tooltip]="autoRestockBtnTooltip | translate"
          (click)="actionButtonClicked('auto_restock')"
        >
          {{ autoRestocksButton.caption | translate }}
        </button>
        <button
          *ngIf="printSheetButton && showPrintSheet"
          data-e2e-id="xux-print-opening-sheets-btn"
          type="button"
          class="btn xux-btn btn-default"
          (click)="actionButtonClicked('print_sheets')"
        >
          {{ printSheetButton.caption | translate }}
        </button>
        <button
          *ngIf="getAddBtnLogic()"
          data-e2e-id="xux-create-btn"
          type="button"
          class="btn xux-btn btn-primary"
          [disabled]="(createButton.disabledObs | async) || createButton.disabled || inShowDeletedMode"
          (click)="actionButtonClicked('create')"
        >
          {{ createButton.caption | translate }}
        </button>

        <button
          *ngIf="cancelStandWorkSheetButton && showCancelOpeningSheetBtn"
          type="button"
          class="btn xux-btn btn-default"
          [disabled]="(cancelStandWorkSheetButton?.disabledObs | async) || !(items$ | async).length"
          (click)="actionButtonClicked('cancel_opening_stand_sheet')"
        >
          {{ cancelStandWorkSheetButton.caption | translate}}
        </button>

        <div
          [ngClass]="{ 'xux-dropdown btn-group pull-right': true,
                   'stand-worksheet-list-btn-dropdown': this.isStandWorksheetRouter,
                   'historical-quantities-list-btn-dropdown': this.isHistoryQuantitiesRouter }"
          *ngIf="getAddBtnGroupLogic()"
        >
          <button
            type="button"
            class="btn btn-default btn-primary"
            (click)="actionButtonClicked('create')"
            [disabled]="(createButton.disabledObs | async) || createButton.disabled || inShowDeletedMode"
            data-e2e-id="edit-xux-btn-save"
          >
            {{ createButton.caption }}
          </button>
          <button
            type="button"
            class="btn btn-default btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-e2e-id="edit-xux-btn-toggle-dropdown"
          >
            <i class="glyphicon glyphicon-menu-down"></i>
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <ul class="dropdown-menu" *ngIf="cancelStandWorkSheetButton">
            <li>
              <button
                type="button"
                class="btn xux-btn btn-default"
                [disabled]="(cancelStandWorkSheetButton?.disabledObs | async) || !(items$ | async).length"
                (click)="actionButtonClicked('cancel_opening_stand_sheet', null)"
              >
                {{ cancelStandWorkSheetButton?.caption | translate }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <xvi-label
    *ngIf="warningMessage$|async"
    [title]="warningMessage$| async "
    [itemClass]="warningLabelClass"
  ></xvi-label>
  <xux-grid
    #listGrid
    *ngIf="!useCustomGrid"
    class="xux-list"
    [class.show-deleted-mode]="inShowDeletedMode"
    [ngClass]="classes"
    data-e2e-id="xux-list"
    [items]="items$ | async"
    [columns]="columnDefinitions"
    [view]="viewConfig"
    [options]="gridOptions"
    [buttons]="actionButtons"
    [rowButtons]="rowActionButtons"
    [showLoader]="getIsShowLoad() | async"
    [userComponents]="xviCustomGridComponents"
    [pageCount]="pageCount$ | async"
    [userGridOptions]="userGridOptions"
    [i18n]="staticI18nTextContent.xuxGrid"
    (action)="onGridAction($event)"
  >
  </xux-grid>
  <xux-grid-custom
    #listGrid
    *ngIf="useCustomGrid"
    class="xux-list"
    [class.show-deleted-mode]="inShowDeletedMode"
    [ngClass]="classes"
    data-e2e-id="xux-list"
    [items]="items$ | async"
    [columns]="columnDefinitions"
    [view]="viewConfig"
    [options]="gridOptions"
    [buttons]="actionButtons"
    [rowButtons]="rowActionButtons"
    [showLoader]="getIsShowLoad() | async"
    [userComponents]="xviCustomGridComponents"
    [pageCount]="pageCount$ | async"
    [userGridOptions]="userGridOptions"
    [i18n]="staticI18nTextContent.xuxGrid"
    (action)="onGridAction($event)"
  >
  </xux-grid-custom>
</div>
